import React, { ReactNode } from "react";

interface MessageBlockProps {
  children: ReactNode;
}

export const MessageBlock = ({ children }: MessageBlockProps): React.ReactElement => {
  return (
    <div className="center-div">
      <div className="text-center">{children}</div>
    </div>
  );
};
